import React, { Component } from "react";
import MFASSOContainer from "../shared/containers/MFASSOContainer";
import Content from "../../content/Content";
import Store from "../../content/Store";
import mfaErrorStyles from "../../assets/css/modules/mfa/mfaErrorPage.css";
import { B2CSignOut } from "../../helpers/LogoutHelper";
import { Paths } from "../../constants/UrlConstants";
import mfaStyles from "../../assets/css/modules/containers/MFASSOContainer.css";

export class MFAErrorPage extends Component {
  constructor(props){
    super(props);
    this.OnClickHandler = this.OnClickHandler.bind(this);
  }
  OnClickHandler(){
     window.embeddedservice_bootstrap?.userVerificationAPI?.clearSession(true);
     B2CSignOut();
     this.props.history.push(Paths.HomeRoot);
  }

render() {
    return (
      <MFASSOContainer>
        <div className={mfaErrorStyles.ErrorPage}>
          <h1 className={`axa-headline ${mfaErrorStyles.title}`}>
            {Store.MFAErrorPage.Heading}
          </h1>
          <div className={mfaErrorStyles.Description}>
          <Content
                        name={Store.MFAErrorPage.Description}
                      />
          </div>
            <div>
            <button
              label={Store.MFAErrorPage.button}
              className={mfaStyles.buttonStart}
              onClick={this.OnClickHandler}
            >{Store.MFAErrorPage.button}</button>
          </div>
          <div className={mfaErrorStyles.logginginlinkButton}>
                    {Store.MFAErrorPage.link}
          </div>
        </div>
      </MFASSOContainer>
    );
  }
}

export default MFAErrorPage;